import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38afc46a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/partner-scss/style.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "../../assets/partner-scss/partners/shoper/_global.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports